import script from "./CollabStatistics.vue?vue&type=script&setup=true&lang=js"
export * from "./CollabStatistics.vue?vue&type=script&setup=true&lang=js"

import "./CollabStatistics.vue?vue&type=style&index=0&id=9c7199a6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c7199a6"]])

export default __exports__